
import React, { useState } from 'react';
import { IoMdClose } from "react-icons/io";

import { useGlobalState } from '../../../global_state_components/GlobalStateProvider.jsx';
import {useAuth} from '../../../global_state_components/AuthProvider.jsx';
import styles from './sessionClickedOverlayForDiscussAndLearn.module.css';

import StrangersList from '../../../miscellaneous/StrangersList/StrangersList.jsx';

function SessionClickedOverlayForDiscussAndLearn(){
  const {isMobile, topic, setTopic, bookWithFriendsButtonRef, bookWithStrangersButtonRef, heightOfCalendarGrid, showStrangersList, setShowStrangersList, setShowFriendsList} = useGlobalState();
  const {isAuthenticated} = useAuth();

  //----Entered topic handling (down)--------------------
  //const [topic, setTopic] = useState('');

  const handleTopicChange = (event) => {
    setTopic(event.target.value);
  };

  const handleBookingWithStrangers = () => {
    //props.clickedGridTimeInDayHourTime

    //console.log("sessionClickedOverlayForDiscussAndLearn is authenticated : "+isAuthenticated);
    if (isAuthenticated==='authenticated') {
      setShowStrangersList(prev => !prev);
      //console.log("sessionClickedOverlayForDiscussAndLearn is showStrangersList : "+ showStrangersList);
    } else {
      // Optional: Add some alert or feedback if not authenticated
      alert("You need to login to book.");
    }
  };

  const handleBookingWithFriends = () => {
    //console.log("sessionClickedOverlayForDiscussAndLearn is authenticated : "+isAuthenticated);
    if (isAuthenticated==='authenticated') {
      setShowFriendsList(prev => !prev); // Toggle the dropdown
    } else {
      // Optional: Add some alert or feedback if not authenticated
      alert("You need to login to book.");
    }
  }


  return(
    <div className={styles.clicked_overlay} style={{height : `${6*heightOfCalendarGrid+3}px`}}>
      {/*(showStrangersList===true)&&(<StrangersList />)*/}
      
      <button onClick={handleBookingWithStrangers} ref={bookWithStrangersButtonRef} className={styles.slot_book_any_button}> Book </button>
      
      <button onClick={handleBookingWithFriends} ref={bookWithFriendsButtonRef} className={styles.slot_book_friend_button}> Book with a friend</button>

      <div className={styles.enter_topic_message_div}>Enter topic you wish to learn in the subject before booking</div>
      <input
        type="text"
        placeholder="Enter topic if any..."
        value={topic}
        onChange={handleTopicChange}
        className={styles.topic_input}
      />      
      {/*<IoMdClose onClick={()=>setShowFriendsList(false)} className={styles.close_icon}/>*/}
    </div>
  );
}

export default SessionClickedOverlayForDiscussAndLearn;

